// Written by claude-scripts/import-demo-client-photos.sh from the developer's download of the Pexels
// collection it names. Do not edit by hand: run the script again to change the set.
/** The invented caseload's photos, as paths the app serves, each a few kilobytes. */
export const DEMO_CLIENT_PHOTO_FILES: string[] = [
    '/assets/images/demo-clients/01.jpg',
    '/assets/images/demo-clients/02.jpg',
    '/assets/images/demo-clients/03.jpg',
    '/assets/images/demo-clients/04.jpg',
    '/assets/images/demo-clients/05.jpg',
    '/assets/images/demo-clients/06.jpg',
    '/assets/images/demo-clients/07.jpg',
    '/assets/images/demo-clients/08.jpg',
    '/assets/images/demo-clients/09.jpg',
    '/assets/images/demo-clients/10.jpg',
    '/assets/images/demo-clients/11.jpg',
    '/assets/images/demo-clients/12.jpg',
    '/assets/images/demo-clients/13.jpg',
    '/assets/images/demo-clients/14.jpg',
    '/assets/images/demo-clients/15.jpg',
    '/assets/images/demo-clients/16.jpg',
    '/assets/images/demo-clients/17.jpg',
    '/assets/images/demo-clients/18.jpg',
    '/assets/images/demo-clients/19.jpg',
    '/assets/images/demo-clients/20.jpg',
    '/assets/images/demo-clients/21.jpg',
    '/assets/images/demo-clients/22.jpg',
    '/assets/images/demo-clients/23.jpg',
    '/assets/images/demo-clients/24.jpg',
    '/assets/images/demo-clients/25.jpg',
    '/assets/images/demo-clients/26.jpg',
    '/assets/images/demo-clients/27.jpg',
    '/assets/images/demo-clients/28.jpg',
    '/assets/images/demo-clients/29.jpg',
    '/assets/images/demo-clients/30.jpg',
    '/assets/images/demo-clients/31.jpg',
    '/assets/images/demo-clients/32.jpg',
    '/assets/images/demo-clients/33.jpg',
    '/assets/images/demo-clients/34.jpg',
    '/assets/images/demo-clients/35.jpg',
    '/assets/images/demo-clients/36.jpg',
    '/assets/images/demo-clients/37.jpg',
    '/assets/images/demo-clients/38.jpg',
    '/assets/images/demo-clients/39.jpg',
    '/assets/images/demo-clients/40.jpg'
];
